/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { PropertyService } from 'src/app/services/property.service';
import { PropertySelectComponent } from '../../property-select/property-select.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-manage-property',
    templateUrl: './manage-property.component.html',
    styleUrls: ['./manage-property.component.css'],
    standalone: true,
    imports: [CommonModule, PropertySelectComponent, ReactiveFormsModule,RouterModule]
})
export class ManagePropertyComponent implements OnInit, OnDestroy{

  private propertySub: Subscription;


  constructor() {
    const propertyService = inject(PropertyService);

    this.propertySub = propertyService.properties.subscribe(properties => {

    })
   }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
      this.propertySub.unsubscribe();
  }

}
